import React from "react";

import { useFormikContext } from "formik";

import { AudienceEnum } from "../../../../enums/template";
import { Template } from "../../../../models";

import CustomSelect, {
  OptionType,
} from "../../../../components/form/CustomSelect";

const audienceOptions: OptionType[] = [
  {
    value: null,
    label: "None",
    description: "",
  },
  {
    value: AudienceEnum.SELF_EMPLOYED_SOLO,
    label: "Self-employed / Solo",
    description: "Self-employed individuals and solo operators running a one-person business",
  },
  {
    value: AudienceEnum.FREELANCERS_CONTRACTORS,
    label: "Freelancers & Contractors",
    description: "Freelancers and independent contractors who bill clients for their own work",
  },
  {
    value: AudienceEnum.SMALL_BUSINESS_1_10,
    label: "Small Business (1-10)",
    description: "A small business owner running a team of roughly 1 to 10 people",
  },
  {
    value: AudienceEnum.MID_MARKET,
    label: "Mid-Market",
    description: "An operations leader at a mid-market company coordinating across teams",
  },
  {
    value: AudienceEnum.ENTERPRISE,
    label: "Enterprise",
    description: "A buyer at a large enterprise evaluating tools for company-wide rollout",
  },
  {
    value: AudienceEnum.AGENCY,
    label: "Agency",
    description: "An agency managing work and billing across multiple client accounts",
  },
  {
    value: AudienceEnum.CONSUMER,
    label: "Consumer",
    description: "An individual consumer using this for personal, non-business purposes",
  },
];

export default function AudienceSelector() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  return (
    <div className="mb-6">
      <CustomSelect
        label="Audience"
        placeholder="-"
        options={audienceOptions}
        selected={audienceOptions.find(
          (option) => option.value === values?.audienceId
        )}
        tooltip="Who this article is written for. The article stays consistent with this reader throughout, and avoids language that only makes sense for a different kind of audience."
        setSelected={(option) => {
          setFieldValue("audienceId", (option?.value as AudienceEnum) || null);
        }}
      />
    </div>
  );
}
